// 2020-06-27export { TropaTransporteComponent } from './tropa-transporte.component';